<template>
    <div>
        <q-dialog v-model="show" :maximized="maximized" @input="(val) => {
            $emit('input', val)
            this.model = {}
        }">
            <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
                <q-header class="bg-primary ">
                    <q-toolbar class="header">
                        <q-toolbar-title>
                            <translate>ADD_FILE</translate>
                        </q-toolbar-title>
                        <q-btn v-close-popup flat round icon="close" />
                    </q-toolbar>
                </q-header>
                <q-page-container class="scroll ">
                    <q-form @submit.prevent="save" class="q-gutter-md">
                        <div class="q-pa-md row col-12 form">
                            <q-file v-model="model.file" :label="this.$gettext('PICK_A_FILE')" filled counter
                                class="col-12" :filter="pdfFilter"
                                :rules="[val => !!val || this.$gettext('REQUIRED_FIELD')]">
                                <template v-slot:prepend>
                                    <q-icon name="folder_open" />
                                </template>
                            </q-file>
                            <q-input outlined v-model="model.observation" :label="this.$gettext('ADD_OBSERVATION')"
                                :dense="dense"
                                class="col-12" />
                        </div>
                        <div class="buttons">
                            <q-btn label="Cancelar" type="reset" color="primary" flat class="q-ml-sm" v-close-popup
                                @click="() => model = {}" />
                            <q-btn :label="$gettext('SAVE')" type="submit" color="primary" />
                        </div>
                    </q-form>
                </q-page-container>
            </q-layout>
        </q-dialog>
    </div>
</template>
<script>

import { Component, Vue } from 'vue-property-decorator'
import { repository, messageBox } from 'jtech'

@Component({
  name: 'AnnexReport',
  components: {},
  props: {
    show: Boolean,
    isCommercialChange: {
      type: Boolean,
      required: false,
      default: false
    }
  }

})
class AnnexReport extends Vue {
    model = {
      observation: ''
    }

    save () {
      if (this.isCommercialChange) this.model.new = true
      this.$emit('save', this.model)
    }

    hide () {
      this.model = {}
      this.$emit('input', false)
    }

    pdfFilter (files) {
      const filesFiltered = files.filter(file => {
        const fileName = file.__key.toLowerCase()
        const lastDotIndex = fileName.lastIndexOf('.')
        const isPdf = lastDotIndex !== -1 && fileName.substring(lastDotIndex, lastDotIndex + 4) === '.pdf'
        if (!isPdf) {
          messageBox.warn(this.$gettext('ACCEPT_JUST_PDF_FILE_TYPE'))
        }
        return isPdf
      })
      return filesFiltered
    }
}
export default AnnexReport

</script>
<style lang="stylus" scoped>
.space {
    padding-left: 24px;
}

.form {
    margin-bottom: 30%;
}

.buttons {
    display: flex;
    justify-content: center;
    gap: 24px;
}

</style>
